import { gql } from '@grandvisionhq/graphql';

const SAVE_NEW_CONSENT = gql`
  mutation SaveNewConsent($customerId: ID!, $consents: [ConsentInput!]!) {
    saveNewConsents(customerId: $customerId, consents: $consents) {
      customerId
      consentName
      success
      errorMessage
    }
  }
`;

export { SAVE_NEW_CONSENT };
//# sourceMappingURL=save-new-consent.js.map
